exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timelineitem[data-v-1234c206]{margin-bottom:-8px;font-size:13px}.el-timeline-item[data-v-1234c206]{padding-bottom:8px !important}", ""]);

// exports
